export default __webpack_public_path__ + "static/media/start.329d15da.svg";